import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { DASH_COLORS, GAUGE_SEGMENTS, VBAR_SEGMENTS } from '../../../../utils/dashboard.utils';

@Component({
  standalone: true,
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.scss'],
  imports: [CommonModule, NgChartsModule],
})
export class GaugeChartComponent implements OnInit, OnChanges {
  @Input() chartData: any;
  @Input() chartOptions: any;
  @Input() colorSegments: string[];
  @Input() description: any[];
  @Input() descriptionPosition: string = 'above';
  @Input() bottomLeftLabel: string = 'Non livres';
  @Input() bottomRightLabel: string = 'Livres';
  @Input() progressPercentage: number = 0;

  colorSegmentsResolved: string[] = [];
  resolvedData: number[] = [];
  resolvedLabels: any[] = [];
  gaugeAngle: number = -90;

  ngOnInit() {
    this.ensureOptions();
    this.updateResolvedData();
    this.resolveColors();
    this.updateGaugeAngle();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ensureOptions();
    this.updateResolvedData();
    this.resolveColors();
    this.updateGaugeAngle();
  }

  get vbarColors(): string[] {
    return VBAR_SEGMENTS;
  }

  getVbarColorAt(index: number): string {
    const colors = this.vbarColors;
    if (!colors || !colors.length) {
      return '#ccc';
    }
    return colors[index % colors.length];
  }

  private ensureOptions(): void {
    if (!this.chartOptions) {
      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        rotation: 270,
        circumference: 180,
        cutout: '70%',
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        animation: false,
      };
    }
  }

  private updateResolvedData(): void {
    let dataArr: number[] = null;
    let labelsArr: any[] = null;

    if (this.chartData) {
      if (this.chartData.data && this.chartData.data.length >= 0) {
        dataArr = this.chartData.data;
        labelsArr = this.chartData.labels || [];
      } else if (this.chartData.datasets && this.chartData.datasets.length > 0) {
        const ds = this.chartData.datasets[0];
        if (ds && ds.data) {
          dataArr = ds.data;
        }
        labelsArr = this.chartData.labels || [];
      }
    }

    if (!dataArr || dataArr.length === 0) {
      dataArr = [25, 25, 25, 25];
      labelsArr = [];
    }

    this.resolvedData = dataArr.slice(0);
    this.resolvedLabels = labelsArr && labelsArr.slice ? labelsArr.slice(0) : labelsArr;
  }

  private resolveColors(): void {
    if (this.colorSegments && this.colorSegments.length) {
      this.colorSegmentsResolved = this.colorSegments;
      return;
    }
    let len = this.resolvedData ? this.resolvedData.length : 0;
    if (len < 2) {
      len = 4;
    }
    const half = len / 2;
    let i,
      colors = [];
    for (i = 0; i < len; i++) {
      if (i < half) {
        colors.push(DASH_COLORS.restalivrer);
      } else {
        colors.push(DASH_COLORS.livre);
      }
    }
    this.colorSegmentsResolved = colors;
  }

  private updateGaugeAngle(): void {
    let p = this.progressPercentage;
    if (p < 0) {
      p = 0;
    }
    if (p > 100) {
      p = 100;
    }
    this.gaugeAngle = -90 + p * 1.8;
  }
}
